export const CashType = {
    CashableWin: 'CashableWin',
    NonCashable: 'NonCashable',
} as const;

export type CashType = typeof CashType[keyof typeof CashType];
